<template>
  <v-container fluid>
    <v-row dense>
      <!-- ERRORS -->
      <v-col v-if="errors.length" cols="12">
        <v-alert
          v-for="(item, index) in errors"
          :key="index"
          dense
          type="error"
          outlined
          dismissible
          class="mb-2"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>

      <!-- CUSTOMER NAME -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="name"
          label="Customer Name"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- AMOUNT PAID -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model.number="paid"
          label="Amount Paid"
          type="number"
          prefix="₱"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- DATE -->
      <v-col cols="12">
        <v-text-field
          v-model="date"
          label="Date"
          type="date"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- BUTTON -->
      <v-col cols="12" class="mt-2">
        <v-btn
          color="primary"
          block
          :loading="storing"
          :disabled="!name || !paid || !date"
          @click="store"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          Add Payment
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.v-alert {
  border-radius: 6px;
}

.v-btn {
  letter-spacing: 0.3px;
}
</style>
<script>
import CLTRepository from '@/repositories/consumer-loan-transaction.repository'
import { errorHandler } from '@/extra-functions/store.extra'
import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
export default {
  name: 'CreateConsumerLoanTransaction',
  props: {
    propConsumerLoanId: String,
    propConsumerId: String,
  },
  data() {
    return {
      name: null,
      date: null,
      paid: null,
      storing: false,
      errors: [],
    }
  },
  methods: {
    store() {
      if (!this.storing) {
        this.storing = true
        this.errors = []
        const data = {
          id: indexKeyGenerator(),
          consumer_loan_id: this.propConsumerLoanId,
          payer_name: this.name,
          date_transaction: this.date,
          amount_paid: this.paid,
        }
        const params = {
          consumer: this.propConsumerId,
          consumerLoan: this.propConsumerLoanId,
        }
        CLTRepository.store(params, data)
          .then(() => {
            this.resetField()
          })
          .catch((e) => {
            this.errors = errorHandler(e)
          })
          .then(() => {
            this.storing = false
          })
      }
    },
    resetField() {
      this.name = null
      this.date = null
      this.paid = null
    },
  },
}
</script>
